import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Compass, Tv, Heart, Users } from "lucide-react";

// Child/family-friendly sticky bottom navigation for phones only (md:hidden).
// Lives in Layout, so it never renders over the immersive Kingdom game or dashboards
// (those routes are outside Layout). Respects iOS safe-area insets.
const ITEMS = [
  { to: "/", label: "Kingdom", Icon: Home, end: true },
  { to: "/activities", label: "Activities", Icon: Compass },
  { to: "/watch", label: "Watch", Icon: Tv },
  { to: "/feelings", label: "Heart Garden", Icon: Heart },
  { to: "/kingdom", label: "Grown-Ups", Icon: Users },
];

export default function MobileTabBar() {
  return (
    <nav data-testid="mobile-tabbar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-black/5 shadow-[0_-6px_20px_rgba(122,60,179,0.08)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <ul className="grid grid-cols-5">
        {ITEMS.map(({ to, label, Icon, end }) => (
          <li key={to}>
            <NavLink to={to} end={end} data-testid={`tab-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 min-h-[58px] px-1 pt-1.5 pb-1 transition-colors ${
                  isActive ? "text-purpleK" : "text-ink/55 active:text-purpleK"}`}>
              {({ isActive }) => (
                <>
                  <span className={`grid place-items-center h-8 w-8 rounded-full transition-colors ${isActive ? "bg-purpleK/12" : ""}`}>
                    <Icon size={20} strokeWidth={2.5} />
                  </span>
                  <span className="font-display font-bold text-[10px] leading-none truncate max-w-full">{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
